module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("设备详情")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v("设备状态")]), _vm._v(" "), _c('DeviceStatus', {
    attrs: {
      "uid": _vm.deviceUid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "detail-title title-margin"
  }, [_vm._v("坐位体前屈设备")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.upgradeList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "80",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "设备类型",
      "prop": "deviceType"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "当前版本",
      "prop": "versionCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "更新日期",
      "prop": "updateTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近配置的更新",
      "prop": "lastVersionCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickUpdate(row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": "设备更新",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.updateDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickUpdateDone
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.updateDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog, "visible", $$v)
      },
      expression: "updateDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择固件版本:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择固件版本",
      "filterable": ""
    },
    model: {
      value: (_vm.updateDialog.selectId),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog, "selectId", $$v)
      },
      expression: "updateDialog.selectId"
    }
  }, _vm._l((_vm.updateDialog.data), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本描述内容:"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.updateDialog.content[_vm.updateDialog.selectId]))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d284090!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentSit/EquipmentSitDetail.vue
// module id = 1109
// module chunks = 0